import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux'
import styled from "styled-components";

import {withRouter} from "react-router";
import {Box, Card, Flex, Heading, Text} from 'rebass';

import {schoolSelectors} from "../../store/school";
import {authSelectors} from "../../store/auth";
import {searchActions, searchSelectors} from "../../store/search";
import {filterStudentsByName} from "../../utils";


import {ColumnIcon, GridIcon} from "../../components/Base/Icons";
import {Content, DesktopBox, MobileBox, MobileHeader, PositionBox, Toolbar} from "../../components/Base";
import {ResumeCheckin} from "../../components/Cards";

import UserList from '../../components/UserList'
import Loading from '../../components/Base/Loading'
//import SearchInput from '../../components/Forms/SearchInput'
import BasicSearch from '../../components/Forms/BasicSearch'
import StudentSummary from "../../components/StudentSummary";

import FilterDropdown from "../../components/Search/FilterDropdown";
import Checkin from '../Search/Checkin'
import ApplyFilters from '../../components/Search/ApplyFilters'
import ConfirmCheckIn from '../../components/Modals/ConfirmCheckIn'
// import MdCreate from 'react-ionicons/lib/MdCreate'
// import MdTrash from 'react-ionicons/lib/MdTrash'
import MdAdd from 'react-ionicons/lib/MdAdd'
import {Action, Fab} from 'react-tiny-fab';
import '../../resources/css/fab.css';
import {AutoFocusInside} from "react-focus-lock";
import {CheckCircle} from "styled-icons/fa-solid";

const Check = styled(CheckCircle)`
  width: 20px;
  height: 20px;
  color: white;
`;

// import {Circle} from "styled-spinkit";
/* icon imports */
const SidebarWrapper = styled(Card)`
min-width: 250px;
	height: calc(100vh - 131px);
	margin-bottom: 10px;
   overflow-x: auto; /* [1] */
  -webkit-overflow-scrolling: touch; /* [4] */
  -ms-overflow-style: -ms-autohiding-scrollbar; /* [5] */
  @media(max-width: 700px){
  	height: 70vh;

  }
`;

const SidebarBox = styled(Box)`
min-width: 250px;

`


class MyDorm extends Component {
	state = {
		students: null,
		columnView: false,
		detailsView: false,
		currentStudent: null,
		leaves: [],
		searchTerm: '',
		checkInSearchTerm: '',
		newLeaves: [],
		pendingLeaves: [],
		searchResult: [],
		showWaveHistory: false,
		loading: true,
		showCheckin: false,
		recentCheckin: null,
		openRecentCheckin: false,
		isCheckin: true,
		draftCheckIn: [],
		isLoading: false,
		toggleConfirmCheckIn: false
	};

	componentDidMount() {
		const {profile, updatePlaceholder} = this.props;
		updatePlaceholder("Search dorm...")

		this.listener = this.fetchListener(profile);
		this.fetchRecentCheckin();
	}

	fetchRecentCheckin = async () => {
		const {profile, firebase} = this.props;
		try {
			let checkinRef = await firebase.checkins().where('type', '==', 3).where('creator_uid', '==', profile.id).where('active', '==', true).orderBy('created_at', 'desc').limit(1).get();
			let result = [];
			checkinRef.docs.forEach(doc => result.push({id: doc.id, ...doc.data()}));
			if (result.length > 0) {
				if (localStorage.getItem("mobileProfile")) {
					localStorage.removeItem("mobileProfile");
					this.setState({
						openRecentCheckin: true,
						//showCheckin: true
					});
				}
				this.setState({recentCheckin: result[0]})
			}
		} catch (e) {
			//console.log("Error saving checkin: ", e)
		}
	};

	fetchListener = (profile) => {
		const {updateStudents} = this.props;
		if (profile.sub_dorm) {
			return this.listener = this.props.firebase.students().where('sub_dorm', '==', profile.sub_dorm).onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				// console.log(result);
				updateStudents(result)
				this.setState({students: result, loading: false})
			})
		} else {
			this.listener = this.props.firebase.students().where('dorm', '==', profile.dorm).onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				// console.log(result);
				updateStudents(result)
				this.setState({students: result, loading: false})
			})
		}
	}

	handleSelectStudent = async (details, isCheckin = false, selectedItems = []) => {
		const {width, history} = this.props;
		if (isCheckin === true) {
			this.setState({
				isLoading: true
			})
	
		}
		if (width < 700) {
			if (isCheckin === true) {
				localStorage.setItem("mobileProfile", 'true')
			}
			history.push(`/app/profile/${details.id}`)
		} else {
			try {
				//let studentRef = this.props.firebase.student(details.id);
				let leavesRef = await this.props.firebase.leaves().where('student_uid', '==', details.id).orderBy('start_date', 'asc').get();
				let leaveResult = [];
				let waveResult = [];
				//let waveRef = await studentRef.collection('wave_history').orderBy('post_time').get();
				leavesRef.docs.forEach(doc => leaveResult.push({id: doc.id, ...doc.data()}));
				// waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));

				// for(let i in waveResult) {
				// 	let creator;
				// 	let creatorRef = await this.props.firebase.faculty(waveResult[i].creator_uid).get();
				// 	if(creatorRef.data()) {
				// 		creator = {id: creatorRef.id, ...creatorRef.data()};
				// 	} else {
				// 		creatorRef = await this.props.firebase.student(waveResult[i].creator_uid).get();
				// 		creator = {id: creatorRef.id, ...creatorRef.data()};
				// 	}
				// 	waveResult[i].creator = creator;
				// }
				
				details.leaves = leaveResult;
				details.wave = waveResult;
 
				if (isCheckin === true) {
					this.setState({
						showCheckin: false,
						isCheckin: false,
						//draftCheckIn: selectedItems,
						currentStudent: details,
						detailsView: true,
						isLoading: false,
					})
				} else {
					this.setState({
						currentStudent: details,
						detailsView: true
					});
				}
			} catch (err) {
				//console.log('failed to fetch student: ', err)
			}
		}


	};

	setPageView = (isColumn) => {
		this.setState({columnView: isColumn})
	};

	toggleDetailsView = () => {
		this.setState({detailsView: !this.state.detailsView})
	};

	updateSearch = (e) => {
		const {updateSearch} = this.props;
		this.setState({searchTerm: e.target.value})
		updateSearch(e.target.value)
	};

	handleCheckInSearch = (e) => {
		this.setState({checkInSearchTerm: e.target.value})
	}

	toggleConfirmCheckIn = () => {
		this.setState({
			toggleConfirmCheckIn: !this.state.toggleConfirmCheckIn,
			showCheckin: true,
		});
	}


	componentWillUnmount() {
		this.listener();
	}

	render() {
		// const {students} = this.state;
		const { toggleConfirmCheckIn, searchTerm } = this.state;
		const { profile, schoolInfo, loading, filters, clearFilter} = this.props;
		let title = 'My Dorm'
		let dorm = null
		if (profile !== null && schoolInfo && schoolInfo.dormMap) {
			if (profile.sub_dorm) {
				dorm = schoolInfo.subDormMap[profile.sub_dorm]

			} else {
				dorm = schoolInfo.dormMap[profile.dorm]
			}
			if (dorm) {
				title = dorm.name

			}
		}

		if (localStorage.getItem("mobileProfile")) {
			return <Loading />;
		}

		return (
			<Box>

				<MobileHeader>
					<Heading pt={2}>{title}</Heading>
					{/*<MetaText>3/250 words</MetaText>*/}
					<ApplyFilters filters={filters} clearFilter={clearFilter} school={schoolInfo} dormView/>

				</MobileHeader>

				<MobileBox>
					<PositionBox position={'relative'} bottom={'14px'} width={1} zIndex={9999}>
						{/*s*/}

						<BasicSearch search={searchTerm} handleInput={this.updateSearch} placeholder={'Search students...'}/>
					</PositionBox>

				</MobileBox>
				<DesktopBox>
					<Heading textAlign={'center'} pt={2}>{title}</Heading>
				</DesktopBox>
				<Content>
					{loading ? <Loading/> :

						<Fragment>
							{toggleConfirmCheckIn ? <ConfirmCheckIn toggle={this.toggleConfirmCheckIn}/> : null }
							{this.renderStudentSummary()}
							{this.renderCheckin(title)}
							{this.renderFabButton()}
						</Fragment>

					}


				</Content>
			</Box>
		)
	}

	renderStudentSummary = () => {
		const {currentStudent, columnView, detailsView, isLoading, searchTerm} = this.state;

		const { profile, loading, students, schoolInfo, filters, clearFilter, isFaculty} = this.props;


		let listProps = {
			width: [1, 1 / 4],
			mt: [0, 0],
		};
		if (!columnView) {
			listProps = {
				width: 1,
				mt: [0, 3]
			}
		}

		let showUserList = true;
		let showToolbar = true;
		let showDetails = columnView;
		if (detailsView) {
			showToolbar = false;
			showUserList = false;
			showDetails = true
		}
		if (columnView) {
			showToolbar = true;
			showUserList = true;
			showDetails = true
		}
		const showSummary = ( showDetails);
		let searchList = filterStudentsByName(students, searchTerm);
		searchList = searchList.filter(student => student.id !== profile.id)
		return (
			<Fragment>


				{/* DESKTOP Toolbar with Filters and Column/Grid View*/}
				<DesktopBox>
					{showToolbar &&
					<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>

						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>VIEW</Text></Box>
						<Box bg={'transparent'} ml={3} py={2}
						     onClick={() => this.setState({columnView: false, detailsView: false})}>
							<GridIcon color={!columnView ? 'black' : '#969a9b'}/>
						</Box>
						<Box ml={2} py={2} onClick={() => this.setState({columnView: true})}>
							<ColumnIcon color={columnView ? '#00000' : '#969a9b'}/>
						</Box>

						<Box css={{display: 'inline-block'}} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
						                                                  color={'meta'}>FILTER</Text></Box>
						<Box ml={3}>
							<FilterDropdown school={schoolInfo} filters={JSON.parse(JSON.stringify(filters))} clearFilter={clearFilter} dormView/>
						</Box>


						<Box ml={'auto'}/>
						<Box width={1 / 2} pr={2}><BasicSearch search={searchTerm} handleInput={this.updateSearch} placeholder={'Search students...'} /></Box>
					</Toolbar>
					}
				</DesktopBox>

				{(loading || isLoading || localStorage.getItem("mobileProfile")) ? <Loading/> :

					<Flex width={1}>
						{showUserList &&
						<SidebarBox {...listProps} css={{minWidth: '250px'}}>
							<SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]}>
								<UserList students={searchList} handleUserClick={this.handleSelectStudent} withLocation
								          columnView={columnView} infiteScroll current={currentStudent ? currentStudent.id : '1'}/>
							</SidebarWrapper>
						</SidebarBox>}
						{showSummary ?

							<StudentSummary student={currentStudent} showBack={!showToolbar} isFaculty={isFaculty}
							                handleBack={() => {
												if(!this.state.isCheckin) {
													this.setState({
														detailsView: false,
														openRecentCheckin: true,
														isCheckin: true
													})
												}
												this.setState({detailsView: false})
											}} profile={profile}/>
							: <Box/>
						}

					</Flex>}

			</Fragment>
		)
	}


	handleSaveNewCheckin = async (selected, log = '', all) => {
		const {profile, loading, isFaculty, filters} = this.props;

		if(!loading) {
			try {
				let newCheckinRef = this.props.firebase.checkins().doc()
				newCheckinRef.set({
					creator_uid: profile.id,
					is_faculty: isFaculty,
					all,
					present: selected,
					type: 3,
					type_id: profile.sub_dorm,
					duty_log: log,
					filters: filters,
					active: true,
					live: false,
					created_at: Math.floor(Date.now() / 1000),
					updated_at: Math.floor(Date.now() / 1000)
				})
				let newCheckin = await newCheckinRef.get();
				this.setState({recentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
				return newCheckin.id

			} catch (err) {
				//console.log("Error saving checkin: ", err)
			}
		}
	}

	handleUpdateCheckin = async (selected) => {
		const {firebase} = this.props;

		const {recentCheckin} = this.state;
		try {
			let checkinRef = firebase.checkins().doc(recentCheckin.id);

			checkinRef.update({
				present: selected,
				updated_at: Math.floor(Date.now() / 1000)
			});
			let newCheckin = await checkinRef.get();
			this.setState({recentCheckin: {id: newCheckin.id, ...newCheckin.data()}})
			return true
		} catch (e) {
			//console.log("Error saving checkin: ", e)
			return false
		}
	};

	handleCheckinDiscard = () => {
		const {recentCheckin} = this.state;
		if ( recentCheckin !== null) {
			this.setState({recentCheckin: null})
		}
	};

	toggleRecentCheckin = () => {
		const {recentCheckin, openRecentCheckin} = this.state;
		if (openRecentCheckin === false) {
			if (recentCheckin && recentCheckin.filters) {
				// updateFilter(recentCheckin.filters)
				this.setState({openRecentCheckin: true})
			}
		} else {
			this.setState({openRecentCheckin: false})
		}
	}

	renderCheckin = (title) => {
		const {showCheckin, recentCheckin, openRecentCheckin, isCheckin, draftCheckIn, isLoading, detailsView, checkInSearchTerm} = this.state;
		const {profile, students} = this.props;
		let searchList = filterStudentsByName(students, checkInSearchTerm);

		searchList = searchList.filter(student => student.id !== profile.id)
		let recentStudents = []
		if(recentCheckin !== null && recentCheckin.all) {
			recentStudents = searchList.filter(student => recentCheckin.all.includes(student.id))
		}
		return (
			<Fragment>
				{recentCheckin !== null  && !detailsView &&
				<ResumeCheckin toggleRecentCheckin={this.toggleRecentCheckin} checkin={recentCheckin}/>

				}
				{(showCheckin && !isLoading) &&
			<Checkin
				visible={showCheckin} 
				handleSave={this.handleSaveNewCheckin}
				handleDiscard={this.handleCheckinDiscard}
				toggleVisible={() => this.setState({showCheckin: false})}
				students={searchList}
				title={title}
				draftSelected={isCheckin ? draftCheckIn : []}
				handleSelectStudent={this.handleSelectStudent}
				isFaculty={false}
			/>}

				{recentCheckin !== null && openRecentCheckin &&
				<Checkin visible={openRecentCheckin}
						isFaculty={false}
						handleSave={this.handleUpdateCheckin}
						 handleDiscard={this.handleCheckinDiscard}
						 handleSelectStudent={this.handleSelectStudent}
						 draftSelected={isCheckin ? draftCheckIn : []}
				         toggleVisible={() => this.setState({openRecentCheckin: false})} students={recentStudents}
				         previous={recentCheckin} title={'Continue Checkin'}/>}
			</Fragment>
		)
	}


	renderFabButton = () => {
		const {columnView, detailsView} = this.state;

		let showDetails = columnView;
		if (detailsView) {

			showDetails = true
		}
		if (columnView) {

			showDetails = true
		}

		let showFab = true
		if(!columnView && showDetails){
			showFab = false
		}
		return (
			<Fragment>
				{showFab &&
				<Fab
					mainButtonStyles={{marginBottom: '72px', backgroundColor: '#FFC61A', width: '47px', height: '47px'}}
					icon={<AutoFocusInside><MdAdd color={'white'}/> </AutoFocusInside>
					}
					event={'click'}
					actionButtonStyles={{color: 'black'}}
				>
					<Action
						text='Check In'
						onClick={() => {
							if (!localStorage.getItem('isDormCheckedIn')) {
								localStorage.setItem("isDormCheckedIn", 'true')
								this.setState({
									toggleConfirmCheckIn: true,
								})
							} else {
								this.setState({
									showCheckin: true,
								})
							}
						}}
					>
						<Check/>
					</Action>

				</Fab>
				}
			</Fragment>
		)
	}
}

const mapStateToProps = (state) => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	profileInfo: authSelectors.refreshProfile(state.auth),
	// loading: authSelectors.isLoading(state.auth),
	search: searchSelectors.refreshSearch(state.search),
	filters: searchSelectors.refreshFilters(state.search),
	students: searchSelectors.refreshCurrentResults(state.search),

	isFaculty: authSelectors.isFaculty(state.auth),
	loading: searchSelectors.isLoading(state.search)

});

const mapDispatchToProps = dispatch => ({
	updateSearch: (term) => {
		dispatch(searchActions.updateSearch(term));
	},
	updateFilter: (filters) => {
		dispatch(searchActions.updateFilter(filters))
	},
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updatePlaceholder: (placeholder) => {
		dispatch(searchActions.updatePlaceholder(placeholder))
	}
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyDorm))
